// 此种布局不包含了 footer，用于交易页面

import React, { Suspense, ReactNode } from 'react';
import Header from '@/components/header';
import cx from 'classnames';
import cs from './index.module.scss';
import FullPageLoading from '@/components/fullPageLoading';

interface Props {
  children: ReactNode;
}

const PageLayout: React.FC<Props> = ({ children }) => (
  <div className={cx('custom-scrollbar layout-container', cs.container)}>
    <Suspense fallback={<FullPageLoading />}>
      <Header />
      <div className={cx(cs.content, 'content')}>{children}</div>
    </Suspense>
  </div>
);

export default PageLayout;
